import { EditSquareIcon } from "../../../../../assets/icons";
import TextArea from "../../../../../components/TextArea";
import Modal from "../../../../../components/Modal";
import styles from './style.module.scss';
import { useState } from "react";

interface Props {
    addFunc: (q: string) => void;
    closeFunc: () => void;
};

export default function AddNewInterviewQuestion(props: Props) {
    const { addFunc, closeFunc } = props;
    const [question, setQuestion] = useState('');

    return (
        <Modal
            size='md'
            title='Add new question'
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={closeFunc}
            actions='both'
            restrictActionsWidth
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                onClick: closeFunc,
            }}
            confirmButton={{
                text: 'Add',
                type: 'Primary',
                disabled: !question.trim(),
                onClick: () => addFunc(question),
            }}
        >
            <span className={styles.label}>
                Write the question you would like to be asked:
            </span>
            <TextArea
                maxLength={200}
                value={question}
                onChange={setQuestion}
            />
        </Modal>
    )
};
